module.exports = __webpack_public_path__ + "6d021a00e4144fcf54d46c3cc122d41f.png";